import { Badge, Box } from '@usealloy/component-library';

interface Props {
  riskRatingColor?: string;
  riskRatingLabel?: string;
  variant?: 'entity' | 'session';
}

export const RiskScoreTabLabel = ({
  riskRatingColor,
  riskRatingLabel,
  variant = 'entity',
}: Props) => (
  <Box>
    {variant === 'session' ? 'Session Risk Score' : 'Risk Score'}
    {riskRatingColor && riskRatingLabel && (
      <Badge
        outline
        backgroundColor={riskRatingColor}
        style={{ fontWeight: 'var(--cl-font-weight-regular)' }}
      >
        {riskRatingLabel}
      </Badge>
    )}
  </Box>
);
